module.exports = __webpack_public_path__ + "f6308d519563fd2e95796c8b1fef8ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/graphic_grey.png
// module id = 228
// module chunks = 0